import { configureStore } from "@reduxjs/toolkit";
import checklistReducer from "./checklist.slice";

const store = configureStore({
  reducer: {
    // Add your reducers here
    checklist: checklistReducer
  }
});

export default store;
